export class SetUpFiltersCommand {
  constructor(public payload: string[]) {}
}
